import React, { useState, useEffect } from "react";
import NavBar from "../Components/NavBar";
import ItemCupon from "../Components/ItemCupon";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useNavigate, Link,useParams } from "react-router-dom";
import {
  collection,
  getDocs,
  doc,
  deleteDoc,
  query,
  where,
  addDoc,
  setDoc,
} from "firebase/firestore";

import Box from "@mui/material/Box";
import IncrementadorNum from "./IncrementadorNum";

import TextField from "@mui/material/TextField";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import { db } from "../FirebaseConfig/firebase";
import IconButton from "@mui/material/IconButton";
import ArrowCircleRightRoundedIcon from "@mui/icons-material/ArrowCircleRightRounded";
import "../CSS/usuarios.css";

const MySwal = withReactContent(Swal);

function Cupones() {
	const { id } = useParams();

  const navigate = useNavigate();
  const [cip, setCip] = useState("");
  const [datosCargados, setDatosCargados] = useState(false); // MOSTRAR BARRA DE CARGA

  const [listFilter, setListFilter] = useState([]);
  const [maxAsientos, setMaxAsientos] = useState("0");
  const [codigoCupon, setCodigoCupon] = useState(generateRandomCode());

  //referenciar la DB
  const handleOnChangeCip = (event) => {
    setCip(event.target.value);
    //esNumero(event.target.value);
  };
  //Funcion para eliminar usuarios
  const deleteCupon = async (idCupon) => {
	console.log(id)
    MySwal.fire({
      title: "Eliminar cupón  ",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, eliminar! ",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const usuario = doc(db, `EVENTOS/${id}/CUPONES`, idCupon);
        await deleteDoc(usuario);
        buscarCupones();

        Swal.fire(
          "Eliminado!",
          "El cupón ha sido eliminado",
          "success"
        );
      }
    });
  };

  const buscarCupones = async () => {
    const q = query(collection(db, `EVENTOS/${id}/CUPONES`));
    const querySnapshot = await getDocs(q);
    setListFilter(
      querySnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
    );
    setDatosCargados(true);
  };

  
  const agregarTipodePago = (event) => {
    validarFormulario(event);
  };

  const validarFormulario = (e) => {
    if (cip == "" || maxAsientos == "0" ) {
      MySwal.fire("", "Llenar todos los campos", "error");
    } else {
      store(e);
    }
  };

  const store = async (e) => {
    const comunicadosList = collection(db, `EVENTOS/${id}/CUPONES`);

    MySwal.fire({
      title: "Agregar Cupón? ",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Agregar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        await addDoc(comunicadosList, {
          cip: cip,
		  asientos: maxAsientos,
		  codigo : codigoCupon,
		  estado: "Activo"
        });
        Swal.fire("Agregado", "El cupón ha sido agregado", "success");
        buscarCupones();
        setCip("");
		setMaxAsientos("0")
      }
    });
  };
  function generateRandomCode() {
	const characters = 'ABCDEFGHJKLMNPQRSTUVWXYZ0123456789123456789';
	let code = '';
  
	for (let i = 0; i < 6; i++) {
	  const randomIndex = Math.floor(Math.random() * characters.length);
	  code += characters[randomIndex];
	}
  
	return code;
  }
  //cerrar pagos diferidos
  const cerrar = () => {
    if (localStorage.getItem("nombreLocal") == "CIP") {
      navigate("../panelCDA/eventos");
    } else {
      navigate("../panelAdmin");
    }
  };
  //uso de useEffect
  useEffect(() => {
    buscarCupones();
  }, []);
  if (!datosCargados) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          margin: "0px auto",
          textAlign: "center",
          height: "100vh",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ verticalAlign: "middle", display: "block" }}>
          <div>
            <img
              style={{ height: "300px" }}
              src={require(`../img/docucargando.gif`)}
              alt="esperando"
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="usuarios">
      <NavBar
        titulo="Cupones"
        imagen="cerrar"
        logoTitulo="coupon"
        cerrar={cerrar}
      ></NavBar>
      <div className="usuarios-buscador">
        <Box sx={{ width: 350 }}>
          <Box sx={{ display: "flex", alignItems: "flex-end" }}>
            <TextField
              sx={{ width: 350 }}
              label="Codigo CIP "
              variant="standard"
              value={cip}
			  type="number"
              onChange={handleOnChangeCip}
            />
          </Box>
          <div className="formNumber">
            <label className="label" style={{ marginRight: "40px" }}>
              Asientos permitidos
            </label>
            <IncrementadorNum
              style={{ margin: "30px" }}
              contador={maxAsientos}
              setContador={setMaxAsientos}
            ></IncrementadorNum>
          </div>
          <Box sx={{ display: "flex", alignItems: "flex-end", margin: "20px" }}>
            <div style={{ width: "100%" }}>
              <input
                type="submit"
                value="Agregar"
                className="fau-btnAgregarComunicado"
                onClick={() => {
                  agregarTipodePago();
                }}
              />
            </div>
          </Box>
        </Box>
      </div>

      <div className="usuarios-item">
        {listFilter.map((item) => (
          <div className="usuarios-element" key={item.id}>
            <ItemCupon
              cip={item.cip}
              idCupon={item.id}
              deleteCupon={deleteCupon}
			  asientos = {item.asientos}
			  codigoCupon={item.codigo}
			  estado={item.estado}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default Cupones;
